<template>
    <div class="chat_page">
        <div class="messages" :id="`messages_box`">
            <Message
                v-for="message in messages"
                :message="message" :key="message.id"
                @favoriteMessage="favoriteMessage"
                @bookmarkMessage="bookmarkMessage"
                :ngWord="checkMessageIsNgWord(message.content, ngWords)"
                :isViewMessage="true"
                @showImage="showImage"
            />
        </div>
        <ModalImage
            v-show="imageView.show"
            :url="imageView.url"
            @cancel="imageView.show = false"
        />
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import ChatGroupApi from '@/api/chat-group'
  import MessageApi from '@/api/message'
  import firebase from '@/firebase'
  import Message from '../../components/message'
  import ModalImage from '../../components/modal-image'

  export default {
    components: {
      Message,
      ModalImage
    },
    data () {
      return {
        messageInputFocus: false,
        chatGroup: {},
        messages: [],
        messageContent: '',
        imageView: {
          show: false,
          src: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        ngWords: 'masterData/ngWords'
      })
    },
    methods: {
      ...mapActions({
        setLinks: 'navigator/setLinks',
        toogleFineplayScreenChat: 'navigator/toogleFineplayScreenChat'
      }),
      async fetchData () {
        const loading = this.$loading.show()
        try {
          const chatGroupId = this.$route.params.chatGroupId
          const messageId = this.$route.params.messageId
          const chatGroupRes = await ChatGroupApi.show(chatGroupId)
          const messagesRes = await ChatGroupApi.get_messages({
            id: chatGroupId,
            message_id: messageId,
            order_by: 'ASC',
            limit: 3
          })
          this.chatGroup = chatGroupRes.data.data
          this.messages = messagesRes.data.data
        } catch (e) {
        }
        loading.hide()
      },
      async bookmarkMessage (message) {
        try {
          const isBookmark = !message.is_bookmark
          isBookmark ? await MessageApi.bookmark(message.id) : await MessageApi.unBookmark(message.id)
          const index = this.messages.findIndex(n => n.id === message.id)
          this.messages[index].is_bookmark = isBookmark
        } catch (e) {
        }
      },
      async favoriteMessage (message) {
        try {
          const isFavorite = !message.is_favorite
          const res = isFavorite ? await MessageApi.favorite(message.id) : await MessageApi.unFavorite(message.id)
          const favoriteDisplayNames = res.data.data.join(', ')
          await firebase.updateMessage(message.chat_group_id, message.id, {favorite_display_names: favoriteDisplayNames})
          const index = this.messages.findIndex(n => n.id === message.id)
          this.messages[index].is_favorite = isFavorite
          this.messages[index].favorite_display_names = favoriteDisplayNames
        } catch (e) {
        }
      },
      checkMessageIsNgWord (message_content, listNgWord) {
        let ngWord = []
        if (typeof message_content !== 'undefined') {
          for (let i = 0; i < listNgWord.length; i++) {
            if (message_content.includes(listNgWord[i])) {
              ngWord.push(`「${listNgWord[i]}」`)
            }
          }
        }
        return ngWord
      },
      showImage (url) {
        this.imageView.url = url
        this.imageView.show = true
      }
    },
    async mounted () {
      await this.fetchData()
      this.toogleFineplayScreenChat(false)

      // document.getElementById('messages_box').scrollTop = document.getElementById('messages_box').scrollHeight
      this.setLinks([
        {title: `${this.chatGroup.institution.official_name_kanji}`, route: {name: 'home'}},
        {
          title: `${this.chatGroup.company.short_name} ${this.chatGroup.market_code}`,
          route: {name: 'institutions.show', params: {institutionCode: this.chatGroup.institution_code}}
        }
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/shares/chat.vue